import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminInvestments,
  createAdminInvestment,
  updateAdminInvestment,
  deleteAdminInvestment,
} from "../../api/admin/investments.api";

export const fetchInvestments = createAsyncThunk(
  "admin/investments/fetch",
  async ({ page = 1, limit = 10, search = "", status = "", branch_id = "" }, { rejectWithValue }) => {
    try {
      const res = await getAdminInvestments({ page, limit, search, status, branch_id });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const addInvestment = createAsyncThunk(
  "investments/addInvestment",
  async (payload, { rejectWithValue }) => {
    const res = await createAdminInvestment(payload);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

export const updateInvestment = createAsyncThunk(
  "admin/investments/update",
  async ({ id, investmentData }, { rejectWithValue }) => {
    const res = await updateAdminInvestment(id, investmentData);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return res;
  }
);

export const deleteInvestment = createAsyncThunk(
  "admin/investments/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteAdminInvestment(id);

    if (!res.success) {
      return rejectWithValue(res.message);
    }

    return { id };
  }
);